<template>
    <Cascader :data="counties" :value="value1" @on-change="handleChange" clearable placeholder="请选择地区" change-on-select></Cascader>
</template>
<style scoped>
</style>
<script>
    // GetCounties
    import {mapState,mapActions} from 'vuex';
    export default {
        components: {

        },
        data(){
            return{
                value1: [],
            };
        },
        computed: {
            ...mapState(['counties']),
        },
        props: {
            value:{
                type: [String, Number],
                default: '',
            },
        },
        mounted(){
            this.GetCounties(localStorage.getItem('tenantAreaCode'));
        },
        watch: {
            value:function (val) {
                this.value1 = Array.of(val);
                // console.log(this.value1)
            }
        },
        methods:{
            ...mapActions(['GetCounties']),
            //预览实例关闭时 通知父组件预览关闭了
            handleChange(data){
                console.log(data,8888)
                this.$emit('change', data[data.length-1] || localStorage.getItem('tenantAreaCode'));
                this.$emit('input', data[data.length-1] || localStorage.getItem('tenantAreaCode'));
            },
        },
    };
</script>
<style lang="less" scoped>

</style>
